import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ed484d8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed484d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed484d8')) {
      api.createRecord('3ed484d8', component.options)
    } else {
      api.reload('3ed484d8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3ed484d8&scoped=true&", function () {
      api.rerender('3ed484d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/project-detail/RadarPointList/index.vue"
export default component.exports